import script from "./DesktopSideNav.vue?vue&type=script&setup=true&lang=js"
export * from "./DesktopSideNav.vue?vue&type=script&setup=true&lang=js"

import "./DesktopSideNav.vue?vue&type=style&index=0&id=3236d854&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3236d854"]])

export default __exports__